import { useContext, createContext } from "react";

export const DraggableContext = createContext(null);

export function useDraggableContext() {
  return useContext(DraggableContext);
}
